export enum ViewModelStates {
  New = 0,
  Unchanged = 1,
  Modified = 2,
  NewModified = 3,
  Removed = 4,
  Versioned = 5,
  Research = 6
}
